// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__tDt86","label":"styles_label__K8ihR"};